import { useFetch } from '@chipinside/fetcher'
import { LoadingIconButton } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CSSProperties, useEffect } from 'react'

import { FindMyCowActions } from '#/components/FindMyCow/Types/Actions'
import { Icon } from '#/components/Icon'
import { endpoint } from '#/store/services/endpoints'
import { Sentry, SentryEvent } from '#/store/services/Sentry'

import LinearIndeterminate from '../Loader'
import { FindMyCowElements } from './Types/Elements'

const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
})

const FindMyCowButtonStyled = styled(Button)({
  lineHeight: '16px',
  minHeight: '16px',
  minWidth: 'unset',
  padding: '2px 10px',
})

const FindMyCowGroup = props => {
  const { data, type } = props
  return (
    <Wrapper>
      {data?.filter(Boolean)?.map(item => {
        return (
          <div key={item.id} id={item.id}>
            <FindMyCowElements {...item} type={type} />
          </div>
        )
      })}
      <FindMyCowActions id="find-my-cow-actions" {...props} />
    </Wrapper>
  )
}

export default function FindMyCow(props) {
  const { animal, collar, farm, type } = props
  const controller = {
    animal: endpoint.farm.find_my_cow.animal({ animal, farm }),
    collar: endpoint.farm.find_my_cow.collar({ collar, farm }),
  }

  const { data, isLoading } = useFetch({ controller: controller[type] })

  useEffect(() => {
    Sentry.metrics({
      attributes: { animal, collar, farm, type },
      event: SentryEvent.FIND_MY_COW,
    })
  }, [])

  return (
    <>
      <LinearIndeterminate status={isLoading as any} />
      <FindMyCowGroup data={data} {...props} />
    </>
  )
}

export const FindMyCowButton = ({
  icon,
  onClick,
  style = {},
}: {
  icon?: boolean
  onClick: any
  style?: CSSProperties
}) => {
  if (icon) {
    return (
      <LoadingIconButton
        title={Translate({ messageKey: 'find_item' })}
        size="small"
        color="primary"
        variant="outlined"
        icon={<Icon name="room-outlined" />}
        onClick={onClick}
      />
    )
  }

  return (
    <FindMyCowButtonStyled
      size="small"
      startIcon={<Icon name="room-outlined" />}
      variant="outlined"
      onClick={onClick}
      style={style}
    >
      {Translate({ messageKey: 'find_item' })}
    </FindMyCowButtonStyled>
  )
}
